"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageRowStyles = exports.getTheme = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _types = require("./types");

var _variableColumn = require("./variable-column.styled");

var _themeOptions = require("../../helpers/theme-options");

var _getDeviceName = require("../../helpers/get-device-name");

var _const = require("./const");

var _const2 = require("../../const");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", " {\n      ", "\n    }\n    ", " {\n      ", "\n    }\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n                display: block;\n                max-width: ", "px;\n\n                ", " {\n                  margin-right: 0;\n                  margin-bottom: 30px;\n                  width: 100%;\n                }\n              "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n                max-width: ", "px;\n                width: 100%;\n\n                ", " {\n                  padding-top: ", "px;\n                }\n              "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n                width: auto;\n                max-width: 100%;\n\n                ", " {\n                  padding-top: ", "%;\n                }\n              "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n                width: ", "px;\n              "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n                align-items: center;\n                display: flex;\n                max-width: none;\n                padding-bottom: 0;\n\n                ", " {\n                  margin-right: 30px;\n                  margin-bottom: 0;\n                  max-width: ", "px;\n                  min-width: ", "px;\n                  width: 100%;\n                }\n              "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", " {\n      max-width: ", "px;\n    }\n\n    ", " {\n      max-width: ", "px;\n      width: 100%;\n\n      ", " {\n        ", "\n\n        ", "\n\n        ", "\n      }\n\n      ", " {\n        ", "\n      }\n\n      ", " {\n        ", "\n      }\n    }\n\n    ", " {\n      padding-top: ", "px;\n      position: relative;\n\n      img {\n        height: 100%;\n        left: 0;\n        object-fit: cover;\n        position: absolute;\n        top: 0;\n        width: 100%;\n      }\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getTheme = function getTheme(theme) {
  switch (theme) {
    case _themeOptions.ThemeVariants.SEASHELL:
      return "\n        background-color: ".concat(_uiKit.Colors.secondaryLight, ";\n      ");

    case _themeOptions.ThemeVariants.SEASHELL_ALT:
      return "\n        &:before {\n          background-color: ".concat(_uiKit.Colors.secondaryLight, ";\n          content: '';\n        }\n      ");

    case _themeOptions.ThemeVariants.MOCASSIN:
      return "\n        background-color: ".concat(_uiKit.Colors.secondary, ";\n      ");

    case _themeOptions.ThemeVariants.MOCASSIN_ALT:
      return "\n        &:before {\n          background-color: ".concat(_uiKit.Colors.secondary, ";\n          content: '';\n        }\n      ");

    case _themeOptions.ThemeVariants.CLARET:
      return "\n        background-color: ".concat(_uiKit.Colors.wine, ";\n        color: ").concat(_uiKit.Colors.white, ";\n\n        ").concat(_variableColumn.Headline1, " {\n          color: ").concat(_uiKit.Colors.white, ";\n        }\n      ");

    case _themeOptions.ThemeVariants.CLARET_ALT:
      return "\n        &:before {\n          background-color: ".concat(_uiKit.Colors.wine, ";\n          content: '';\n        }\n\n        ").concat(_variableColumn.Headline1, ",\n        ").concat(_variableColumn.Headline2, ",\n        ").concat(_variableColumn.Headline3, " {\n          color: ").concat(_uiKit.Colors.white, ";\n        }\n      ");

    case _themeOptions.ThemeVariants.BLACK:
      return "\n        background-color: ".concat(_uiKit.Colors.gray800, ";\n        color: ").concat(_uiKit.Colors.white, ";\n\n        ").concat(_variableColumn.Headline1, " {\n          color: ").concat(_uiKit.Colors.white, ";\n        }\n      ");

    case _themeOptions.ThemeVariants.BLACK_ALT:
      return "\n        &:before {\n          background-color: ".concat(_uiKit.Colors.gray800, ";\n          content: '';\n        }\n\n        ").concat(_variableColumn.Headline1, ",\n        ").concat(_variableColumn.Headline2, ",\n        ").concat(_variableColumn.Headline3, " {\n          color: ").concat(_uiKit.Colors.white, ";\n        }\n      ");

    default:
      return "\n        ".concat(_variableColumn.Headline1, " {\n          color: ").concat(_uiKit.Colors.primaryDark, ";\n        }\n      ");
  }
};

exports.getTheme = getTheme;

var getDeviceStyles = function getDeviceStyles(styles, config, container, item, image) {
  var _config$columns = config.columns,
      columns = _config$columns === void 0 ? 2 : _config$columns,
      _config$aspectRatio = config.aspectRatio,
      aspectRatio = _config$aspectRatio === void 0 ? '1:1' : _config$aspectRatio,
      _config$offset = config.offset,
      offset = _config$offset === void 0 ? 30 : _config$offset,
      mobileLayout = config.mobileLayout,
      gridType = config.gridType;
  var deviceName = (0, _getDeviceName.getDeviceName)();
  var desktopWidth = +columns === 5 ? _const.desktopWidthStrategy[_types.KeyValueGridType.SMALL] : _const.desktopWidthStrategy[gridType];
  var deviceWidth = _const.deviceWidthStrategy[[deviceName, mobileLayout]];
  var imageWidth = deviceName === _const2.DeviceName.DESKTOP ? desktopWidth : deviceWidth;
  return (0, _uiKit.css)(_templateObject(), container, (imageWidth + offset) * columns, item, imageWidth, _uiKit.GridBreakpointsMediaDown.lg, mobileLayout === _types.KeyValueMobLayout.STACK ? (0, _uiKit.css)(_templateObject2(), image, imageWidth, imageWidth) : '', mobileLayout === _types.KeyValueMobLayout.SCROLL ? (0, _uiKit.css)(_templateObject3(), imageWidth) : "", mobileLayout === _types.KeyValueMobLayout.CAROUSEL ? (0, _uiKit.css)(_templateObject4(), image, 100 * aspectRatio.split(':').reduce(function (prev, current) {
    return parseInt(prev) / parseInt(current);
  })) : '', _uiKit.GridBreakpointsMediaDown.md, mobileLayout === _types.KeyValueMobLayout.CAROUSEL ? (0, _uiKit.css)(_templateObject5(), imageWidth, image, imageWidth * aspectRatio.split(':').reduce(function (prev, current) {
    return parseInt(prev) / parseInt(current);
  })) : '', _uiKit.GridBreakpointsMediaDown.sm, mobileLayout === _types.KeyValueMobLayout.STACK ? (0, _uiKit.css)(_templateObject6(), imageWidth, image) : '', image, imageWidth * aspectRatio.split(':').reduce(function (prev, current) {
    return parseInt(prev) / parseInt(current);
  }));
};

var getImageRowStyles = function getImageRowStyles(_ref) {
  var _ref$styles = _ref.styles,
      _ref$styles$desktop = _ref$styles.desktop,
      desktop = _ref$styles$desktop === void 0 ? '' : _ref$styles$desktop,
      _ref$styles$tablet = _ref$styles.tablet,
      tablet = _ref$styles$tablet === void 0 ? '' : _ref$styles$tablet,
      _ref$styles$mobile = _ref$styles.mobile,
      mobile = _ref$styles$mobile === void 0 ? '' : _ref$styles$mobile,
      columns = _ref.columns,
      aspectRatio = _ref.aspectRatio,
      mobileLayout = _ref.mobileLayout,
      offset = _ref.offset,
      container = _ref.container,
      child = _ref.child,
      image = _ref.image,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'Image' : _ref$name,
      gridType = _ref.gridType;
  var config = {
    columns: columns,
    aspectRatio: aspectRatio,
    offset: offset,
    mobileLayout: mobileLayout,
    gridType: gridType
  };
  return (0, _uiKit.css)(_templateObject7(), getDeviceStyles(desktop[name], config, container, child, image), _uiKit.GridBreakpointsMediaDown.md, getDeviceStyles(tablet[name], config, container, child, image), _uiKit.GridBreakpointsMediaDown.sm, getDeviceStyles(mobile[name], config, container, child, image));
};

exports.getImageRowStyles = getImageRowStyles;